import { render, staticRenderFns } from "./my-nav-menu.vue?vue&type=template&id=a886bfa4&scoped=true&"
import script from "./my-nav-menu.vue?vue&type=script&lang=js&"
export * from "./my-nav-menu.vue?vue&type=script&lang=js&"
import style0 from "./my-nav-menu.vue?vue&type=style&index=0&id=a886bfa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a886bfa4",
  null
  
)

export default component.exports